import { boolean, pgEnum, pgTable, timestamp, uuid, varchar } from "drizzle-orm/pg-core"
import { estates } from "./estate"
import { permissionRolesEnum } from "./permission"
import { users } from "./users"

export const invitationStatusEnum = pgEnum("invitation_status_enum", [
  "PENDING",
  "ACCEPTED",
  "DECLINED",
  "EXPIRED",
  "AUTO_ACCEPTED",
])

export const invitationTypeEnum = pgEnum("invitation_type_enum", ["PROFESSIONAL_TO_USER"])

export const userInvitations = pgTable("user_invitation", {
  id: uuid("id").primaryKey().defaultRandom(),
  inviterId: varchar("inviter_id", { length: 255 })
    .notNull()
    .references(() => users.id, { onDelete: "cascade" }),
  inviteeEmail: varchar("invitee_email", { length: 255 }).notNull(),
  invitationType: invitationTypeEnum("invitation_type_enum").notNull(),
  estateId: uuid("estate_id").references(() => estates.id, { onDelete: "cascade" }),
  role: permissionRolesEnum("permission_roles_enum").default("STANDARD"),
  status: invitationStatusEnum("invitation_status_enum").notNull().default("PENDING"),
  token: varchar("token", { length: 255 }).notNull().unique(),
  expiresAt: timestamp("expires_at").notNull(),
  acceptedAt: timestamp("accepted_at"),
  createdAt: timestamp("created_at").defaultNow().notNull(),
  updatedAt: timestamp("updated_at").defaultNow().notNull(),
  deletedAt: timestamp("deleted_at"),
  isActive: boolean("is_active").default(true),
})
